import { IConfirmEmailRequest } from "api/models/request/IConfirmEmailRequest";
import { confirmEmail } from "api/services/user-service";
import useApiCall from "hooks/useApiCall"

export const useConfirmEmail = () => {
    const { callAPI, loading } = useApiCall<IConfirmEmailRequest, any>(confirmEmail, 'confirmEmail.success', 'confirmEmail.error');

    return { confirmEmail: callAPI, confirmEmailPending: loading}
}